import React from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FormFor, Submit, TextArea, Select } from "react-rails-form-helpers";
import FormWrapper from "./styles/candidate-actions-ie-form";

const CandidateActionsIEForm = (props) => {
  const { updateStatusLink } = props;

  return (
    <FormWrapper>
      <FormFor
        id="candidate-page-form"
        url={updateStatusLink}
        method="post"
        name="application_action"
        encType="multipart/form-data"
      >
        <Select
          name="action"
          id="candidate-page-select"
          form="candidate-page-form"
        >
          <option value="send_message">Send Message</option>
          <option value="telephone_interview_confirmed">
            Confirm Telephone Interview
          </option>
          <option value="first_interview_confirmed">
            Confirm First Interview
          </option>
          <option value="second_interview_confirmed">
            Confirm Second Interview
          </option>
          <option value="competency_test_completed">Completed test</option>
          <option value="declined_interview">Decline Interview</option>
          <option value="accepted_job">Accept Offer</option>
          <option value="rejected_job">Reject Offer</option>
        </Select>
        <input
          id="date-input"
          name="application_action[action_at]"
          placeholder="MMM D, YYYY, HH:MM"
          type="text"
        />
        <FontAwesomeIcon
          icon={faInfoCircle}
          data-tip="Format: MMM D, YYYY, HH:MM. Example: Sep 7, 2019, 14:30"
          data-for="date-input-tooltip"
          id="date-input-hint-icon"
        />
        <ReactTooltip
          place="left"
          type="dark"
          effect="solid"
          aria-haspopup="true"
          id="date-input-tooltip"
        />
        <TextArea
          placeholder="Enter message here..."
          id="candidate-page-form-textarea"
          name="message"
        />
        <input
          type="file"
          id="candidate-page-file-input"
          name="application_action[attachment]"
        />
        <Submit id="candidate-page-submit-button" name="submit" value="Send" />
      </FormFor>
    </FormWrapper>
  );
};

CandidateActionsIEForm.propTypes = {
  updateStatusLink: PropTypes.string.isRequired,
};

export default CandidateActionsIEForm;
